import { render, staticRenderFns } from "./Drawer copy.vue?vue&type=template&id=2da2a712"
import script from "./Drawer copy.vue?vue&type=script&lang=js"
export * from "./Drawer copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports